import { getMessage } from '@tcc/i18n';
import { ComponentAlign, Container, Orientation, Spinner, Typography, TypographyVariant } from '@tcc/fds';

export const RegionReportSpinner = () => (
  <Container
    width='100%'
    orientation={Orientation.Vertical}
    align={ComponentAlign.Center}
    justify={ComponentAlign.Center} >
    <Spinner />
    <Typography variant={TypographyVariant.Body}>
      {getMessage('regions.report.modal.spinnerMsg')}
    </Typography>
  </Container>
);
